import { useRef, useEffect } from 'react';
import * as React from 'react';
import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import Radiobutton from '@sdk/components/forms/Radiobutton';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { getReasons, getRequireTextDict, getTitle } from './downgradeReason.utils';
import { DowngradeMode } from './downgradeReason.types';
import { Textarea } from './downgradeReason.styles';

const RADIO_NAME = 'downgrade-reason';

type Props = {
  selectedReasonId: number;
  setSelectedReasonId: (id: number) => void;
  selectedReasonText: string;
  setSelectedReasonText: (text: string) => void;
  setReasonRequiresText: (reasonRequiresText: boolean) => void;
  mode: DowngradeMode;
  isBusiness?: boolean;
  showErrors?: boolean;
};

const DowngradeReason = ({
  selectedReasonId,
  setSelectedReasonId,
  selectedReasonText,
  setSelectedReasonText,
  setReasonRequiresText,
  mode,
  isBusiness = false,
  showErrors = false,
}: Props) => {
  const reasonRef = useRef(null);

  const reasons = getReasons(mode, isBusiness);
  const requireTextDict = getRequireTextDict(mode, isBusiness);
  const title = getTitle(mode);

  useEffect(() => {
    reasonRef.current?.focus();
  }, [selectedReasonId, reasonRef]);

  return (
    <>
      <Row mBottom={10}>
        <Text14 semiBold themeColor={ThemeColorType.gray}>
          {title}
        </Text14>
      </Row>
      <Column
        mLeft={10}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.name === RADIO_NAME) {
            const reasonId = Number(e.target.value);
            setSelectedReasonId(reasonId);
            setReasonRequiresText(requireTextDict[reasonId]);
          }
        }}>
        {reasons.map((reason) => {
          return (
            <Column key={reason.id} mTop={10} mBottom={10}>
              <Radiobutton
                fieldName={RADIO_NAME}
                value={reason.id}
                label={reason.reason}
                checked={reason.id === selectedReasonId}
              />
              {Boolean(reason.textRequired && reason.id === selectedReasonId) && (
                <Row mTop={5}>
                  <Textarea
                    ref={reasonRef}
                    placeholder={gettext('Please specify')}
                    value={selectedReasonText}
                    onChange={({ target: { value } }): void => {
                      setSelectedReasonText(value);
                    }}
                    invalid={showErrors && !selectedReasonText}
                  />
                </Row>
              )}
            </Column>
          );
        })}
      </Column>
    </>
  );
};

export default DowngradeReason;
export { DowngradeMode };
